/**
 * Returns true when /version.json reports a version that differs from the
 * one baked into this bundle. Used to decide whether to prompt a reload.
 *
 * Returns false on any failure (network, non-200, parse) — better to under-
 * notify than to spam users with a phantom "update available" toast.
 */
export async function checkForUpdate(currentVersion: string): Promise<boolean> {
  if (currentVersion === 'dev') return false;

  try {
    const res = await fetch('/version.json', {
      cache: 'no-store',
      credentials: 'omit',
    });
    if (!res.ok) return false;
    const data = (await res.json()) as { version?: string };
    if (!data.version) return false;
    return data.version !== currentVersion;
  } catch {
    return false;
  }
}
